import { Special } from '../server/libs/siteSettings';
import { kenshui30ArticleIds } from './libs/kenshui30';

export const URL_CORPORATE_TOP = 'https://corp.antaa.jp';
export const URL_CORPORATE_TERMS = 'https://corp.antaa.jp/terms';
export const URL_CORPORATE_PRIVACY_POLICY =
  'https://corp.antaa.jp/privacypolicy';
export const URL_COPYRIGHT_INFRINGEMENT_FORM =
  'https://docs.google.com/forms/d/e/1FAIpQLSfWaISiyTxGyarkwU91rIUafQzSb_g4mVzPnboybvibrXEKrA/viewform';
export const URL_INQUIRY_FORM = 'https://note.com/antaa/n/n3ae2566cdbb4';
export const URL_INQUIRY_FORM_MULTI =
  'https://docs.google.com/forms/d/1SU0mVpUakAKQ9dhc0M7epJKghj93OFD04fR7Ez6_OrY/viewform';
const FOOTER_STORE_UTM = '&utm_source=antaa_slide_web&utm_medium=footer_link';
export const URL_FIRST_POST_SUPPORT_FORM =
  'https://forms.gle/wCD3k9Ucz82yp3YH6';
export const URL_STORE_GOOGLE = `https://play.google.com/store/apps/details?id=jp.antaa.qa.android.AntaaQa${FOOTER_STORE_UTM}`;
export const URL_STORE_APPLE = `https://apps.apple.com/jp/app/id1151798574?${FOOTER_STORE_UTM}`;
export const URL_IP_GUIDELINE_VIDEO =
  'https://antaa-public.s3.ap-northeast-1.amazonaws.com/slide/ip-guideline/20220817_slide_guideline_archive/20220817_slide_guideline_archive.m3u8';

export const APP_BANNER_CLOSED_LOCAL_STORAGE_KEY =
  'mobile_app_download_banner_closed';

export const TWITTER_ACCOUNT_CORPORATE = '@antaa__jp';

export const URL_ANTAA_FACEBOOK = 'https://www.facebook.com/antaa';

export const URL_ANTAA_TWITTER = 'https://twitter.com/antaa__jp';

export const DEFAULT_TITLE = 'Antaa Slide';

export const ARTICLE_PARTIAL_DISCLOSE_PAGE_COUNT = 3;

export const DEPARTMENT_ID_OTHER = 27;
export const DEPARTMENT_ID_OTHER_STRING = '27';

export const ARTICLE_LIKE_ANNOUNCE_NAME_LENGTH_LIMIT = 30;

export const ONDEMAND_PROFILE_UPDATE_STATUS_MAP = {
  SKIPPED: 'SKIPPED',
  INCOMPLETE: 'INCOMPLETE',
  UPDATED: 'UPDATED',
  DIDNT_UPDATE: 'DIDNT_UPDATE',
  INCOMPLETE_TWICE: 'INCOMPLETE_TWICE',
};

export const HOSPITAL_MAX_FETCH_NUM = 100;

export const AUTHOR_MAX_FETCH_NUM = 100;

export const POPULAR_AUTHOR_MAX_FETCH_NUM = 9;

export const REQUIRED_PRIVACY_POLICY_VERSION = '20240524';
export const REQUIRED_TERMS_OF_SERVICE_VERSION = '20231228';
export const REQUIRED_TERMS_OF_ANTAA_AI_ASSISTANT_VERSION = '20240409';
export const REQUIRED_COMMUNITY_GUIDELINE_VERSION = '20240516';

export const SPECIAL_PAGE_GA_CATEGORY = 'special_contents';

/**
 * 特集ページ、スライド詳細バナー設定値
 * テンプレートで表示している場合はスライド詳細バナー設定のみ
 *
 * 注）バナー定義およびテンプレート使用特集ページの定義は
 * 　　サイト設定ファイルおよび特集ページ構成定義ファイルへ移行
 * 　　したが、個別特集に関する定義は当面ここに残す
 */
export const SPECIALS: {
  [key in string[number]]: Special;
} = {
  picu: {
    name: 'picu',
    alt: 'PICUのフェロー部屋',
    link: '/special/pediatric-intensive-care#menu',
    mainImage: '/images/special/picu_main_1300*720.png',
    detailBannerImage: '/images/special/picu_menu_1316*732.png',
    tags: [],
    // tags: ['PICUのフェロー部屋'],
  },
  kenshui30: {
    name: 'kenshui30',
    alt: '研修医1年目 必見スライド30選',
    link: '/special/kenshui30',
    mainImage: '/images/special/kenshui30_main_1300*720.png',
    detailBannerImage: '/images/special/kenshui30_to_main_1316*732.png',
    tags: [],
    articleIds: kenshui30ArticleIds,
  },
  ctdIld: {
    name: 'ctdIld',
    alt: '膠原病に伴う間質性肺疾患特集',
    link: '/special/ctd-ild',
    mainImage: '/images/special/ctd-ild_main_1300*720.png',
    tags: [],
    andTags: [
      ['CTD-ILD'],
      ['膠原病に伴う間質性肺疾患'],
      ['膠原病に伴う間質性肺炎'],
      ['膠原病', '間質性肺疾患'],
      ['膠原病', '間質性肺炎'],
      ['CTD', 'ILD'],
      ['関節リウマチ', '間質性肺疾患'],
      ['関節リウマチ', '間質性肺炎'],
      ['RA', '間質性肺疾患'],
      ['RA', '間質性肺炎'],
      ['全身性強皮症', '間質性肺疾患'],
      ['全身性強皮症', '間質性肺炎'],
      ['SSc', '間質性肺疾患'],
      ['SSc', '間質性肺炎'],
      ['皮膚筋炎', '間質性肺疾患'],
      ['皮膚筋炎', '間質性肺炎'],
      ['IIMs', '間質性肺疾患'],
      ['IIMs', '間質性肺炎'],
    ],
  },
  clinicalReasoning: {
    name: 'clinicalReasoning',
    alt: '診断推論特集',
    link: '/special/clinical-reasoning',
    mainImage: '/images/special/clinical-reasoning_main_1300*720.png',
    tags: ['診断推論', '臨床推論'],
  },
  ibdUcCd: {
    name: 'ibdUcCd',
    alt: 'IBD特集',
    link: '/special/ibd-uc-cd',
    mainImage: '/images/special/ibd-uc-cd_main_1300*720.png',
    tags: ['IBD', '炎症性腸疾患', '潰瘍性大腸炎', 'UC', 'CD', 'クローン病'],
  },
  hyperkalemia: {
    name: 'hyperkalemia',
    alt: '高カリウム血症特集',
    link: '/special/fec15a463248d6a9',
    mainImage: '/images/special/hyperkalemia_main_500*281.png',
    mobileBannerImage: '/images/special/hyperkalemia_banner_1200*240.png',
    tags: [
      '高カリウム血症',
      '高K血症',
      '腎不全',
      '糖尿病性ケトアシドーシス',
      '腎性糖尿病',
      '利尿薬',
      '高血圧',
      '人工透析',
      '血液透析',
      'ロケルマ',
      'アドレナリン作動薬',
      'エース阻害薬 / ARB薬',
      '代謝性アシドーシス',
      '心電図',
      'アルドステロン拮抗薬',
      '高カリウム',
      'カリウム',
      'カリウム吸着薬',
      'ケイキサレート',
      'アーガメイト',
    ],
  },
  hyperuricemia: {
    name: 'hyperuricemia',
    alt: '高尿酸血症特集',
    link: '/special/hyperuricemia',
    mainImage: '/images/special/hyperuricemia_main_1300*720.png',
    mobileBannerImage: '/images/special/hyperuricemia_banner_1200*240.png',
    tags: [
      '高尿酸血症',
      '関節痛',
      '結晶性関節炎',
      '痛風',
      '尿酸',
      '尿酸検査',
      '血液検査',
      '尿検査',
      '尿酸降下薬',
      'URAT1阻害薬',
      'ユリス',
      'ベネシッド',
      'ユリノーム',
      'ウリアデック',
      'ザイロリック',
      'フェブリク',
      'コルヒチン',
      'ラスリテック',
      'ウラリット',
      '腎臓結石',
      '高血圧',
      '代謝症候群',
      '心血管疾患',
    ],
  },
  privateHealthcare: {
    name: 'privateHealthcare',
    alt: '【新たな選択肢】保険外診療特集',
    link: '/special/private-healthcare',
    mainImage: '/images/special/private-healthcare_main_1300*720.png',
    tags: ['保険外診療', '自由診療', '自費診療'],
  },
  homeMedicalCare: {
    name: 'home-medical-care',
    alt: '在宅医療特集',
    link: '/special/home-medical-care',
    mainImage: '/images/special/home-medical-care_main_1300*720.png',
    tags: ['在宅', '在宅医療'],
    relatedSlidesPreferSpecialTags: true,
  },
  residentInternalMedicine: {
    name: 'resident-internal-medicine',
    alt: '（2025年度）研修医ローテ対策特集',
    link: '/special/resident-internal-medicine',
    mainImage: '/images/special/resident-internal-medicine_main_1300*720.png',
    tags: [],
    articleIds: [
      'eab403cc875346cf',
      '4bbed7ab98be4b9f',
      'ba00107ad2274f8d',
      '654a9dea708940a1',
      '7f4b922bde0844d5',
      'cc445670e5d648e8',
      '091e5754133b4952',
      'ba025bae01234b1e',
      '255bd3705b924e85',
      '87deb1cdfda34b2b',
      'f7ee308253af4eaa',
      'af7cce16de0c47c7',
      '53d757c5cf0347c1',
      '2ee856972d9240b2',
      '6ac7dc0268c54285',
      'f1113c77c467447c',
      '4a3466993f524e06',
      'fd4b1c9c4fc34722',
      'e097b2a75e264a01',
      '153a2057813f40be',
    ],
  },
  designatedIntractableAndRareDiseases: {
    name: 'designatedIntractableAndRareDiseases',
    alt: '難病・希少疾患特集',
    link: '/special/designated-intractable-diseases-and-rare-diseases',
    mainImage:
      '/images/special/designated-intractable-and-rare-diseases_main_1300*720.png',
    tags: ['難病', '希少疾患'],
  },
  residentHandbookCampaign: {
    name: 'residentHandbookCampaign',
    alt: '#研修医の教科書 キャンペーン',
    link: '/special/resident-handbook-campaign',
    mainImage: '/images/special/resident_handbook_campaign_main_1300*720.png',
    tags: [],
    articleIds: [
      '9d0d9549d9c74bde',
      'ff25c07220db4d10',
      'a7899b0b24e848e2',
      '401f1d4292304a4c',
      '5656b4de3a6d402e',
      '1153e03d569d466e',
      'e9e2b9890bb04ec1',
      '2f4c8e3de8ea4a49',
      'e244196a284f4f18',
      'a56d0632ceef4e11',
      '1668e7de08fd4acb',
      '31d618cd004e4bbc',
      'd99fdc6334e04830',
      '271e3806a7ab4b0b',
      '42173f1a16c44314',
      '44ca3a35c0974f00',
      'ce3c5e79fb2d45e3',
      '69fd7aade66e4fe1',
      '9d6b6ddf8e4d4d0c',
      '1ff3e75c588f4602',
      'a744e799aed04b41',
      '92561420026b4441',
      'f09ec4827edf4226',
      '255bd3705b924e85',
      '69d3f7863be3405a',
      'b22eb14771734b3a',
      '9cc4a4c3614a4a9c',
      '81390a52ac5c45a8',
      '5ce8804a81594c31',
      'd169e3ff25aa4aeb',
      'ec5fdc0b9acd41f6',
      'b3da75d06cab4aa8',
      'eef2e9826da94c0e',
      'd4f498a0f7ab41e2',
      'ce054482ba954eb5',
      '54699b083b4242aa',
      'a22fb6140645422b',
      '8f14876d87b4404c',
      'f4b0c6f4666b4a5f',
      '157a375028884d9a',
      'c3c7a38da7df4a64',
      '388e51811fc84d87',
      'd051e1ae40154134',
      '5ca138a7051c492d',
      '6c9c6ca110d04e95',
      '05c80eee5ce54249',
      '3b5b8a77811e4072',
      '7d789dd0a0b34b03',
      'f6d8dbbb670443f5',
      '9136447a9cc048d7',
      '190c5a10ac914622',
      'de743c02c3214053',
    ],
  },
};
